
import { Component, Prop, Vue } from 'vue-property-decorator';
import { NationalEventsInterface } from '@/services/Calendar/NationalEvents/Interfaces';
import NationalEventsRepository from "@/services/Calendar/NationalEvents";

@Component({
  inject: [
    'nationalEventsRepository',
  ],
})
export default class DeleteNationalEventDialog extends Vue {
  private readonly nationalEventsRepository!: NationalEventsRepository;

  @Prop() private readonly nationalEvent!: NationalEventsInterface;

  private visible: boolean = true;

  get message(): string {
    return `Are you sure you want to delete '${this.nationalEvent.name}'?`;
  }

  private async deleteRecurringEvent(): Promise<void> {
    try {
      await this.nationalEventsRepository.deleteNationalEvent(this.nationalEvent.id);
      this.$successDialog.show(`National event '${this.nationalEvent.name}' has been deleted.`);
      this.$emit('deleted-national-event', this.nationalEvent.id);
      this.destroyComponent();
    } catch (e) {
      this.$errorDialog.show(e.response.data.message);
      this.destroyComponent();
    }
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
